'use client';

import { ButtonHTMLAttributes, FC } from 'react';

import { Icon, IconName } from '@purpur/library/icon';

import { getSvgIcon } from '@telialt/common-icon/src';

import { ButtonText, RectangularShapedButton } from './RectangularButton.styles';

type Props = {
    isNegative: boolean;
    children: string;
    rightIcon?: IconName;
    leftIcon?: IconName;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const RectangularButton: FC<Props> = ({ isNegative, rightIcon, leftIcon, children, ...inherited }) => {
    const rightIconSvg = rightIcon && getSvgIcon(rightIcon);
    const leftIconSvg = leftIcon && getSvgIcon(leftIcon);

    return (
        <RectangularShapedButton $negative={isNegative} {...inherited} type="button">
            {!!leftIcon && <Icon svg={leftIconSvg} />}
            <ButtonText>{children}</ButtonText>
            {!!rightIcon && <Icon svg={rightIconSvg} />}
        </RectangularShapedButton>
    );
};
